import React, { FC, ReactElement, useRef, useState } from 'react';
import classNames from 'classnames';
import { Icon } from '@nx-frontend/shared/ui/icon';
import { FloatingPopup, FloatingPopupBaseProps } from './floating-popup';

interface FloatingPopupIconProps extends Omit<FloatingPopupBaseProps, 'show' | 'className' | 'targetRef' | 'onClose'> {
  icon: ReactElement;
  onClose?: () => void;
  iconClassName?: string[];
  popupClassName?: string[];
  targetRef?: React.RefObject<HTMLElement>;
  fill?: boolean;
}

export const FloatingPopupIcon: FC<FloatingPopupIconProps> = ({
  icon,
  iconClassName,
  popupClassName,
  targetRef,
  onClose,
  children,
  fill = false,
  ...popupProps
}) => {
  const iconRef = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);

  const onPopupClose = () => {
    setShow(false);
    onClose?.();
  };

  return (
    <>
      <div
        ref={iconRef}
        className={classNames(
          'cursor-pointer size-7 p-1 rounded hover:bg-neutral-200',
          {
            'bg-neutral-200': show,
            'text-teal-500': fill,
            'text-gray-500': !fill,
          },
          iconClassName
        )}
        onClick={() => setShow(!show)}
      >
        <Icon icon={icon} className="w-full h-full" />
      </div>
      <FloatingPopup
        show={show}
        onClose={onPopupClose}
        className={popupClassName}
        targetRef={targetRef ?? iconRef}
        {...popupProps}
      >
        {children}
      </FloatingPopup>
    </>
  );
};
